<mat-card>
    <mat-form-field appearance="legacy">
      <mat-label>Search gif</mat-label>
      <input matInput placeholder="search ..." autocomplete="off" [formControl]="giphySearch">
      <mat-icon matSuffix>gif</mat-icon>
    </mat-form-field>
  <div class="d-flex flex-wrap">
    <img *ngFor="let g of (giphySearch$ | async)" [src]="g?.images?.downsized_medium?.url" [alt]="g?.title"
         class="gif-spacing" (click)="selectGiphy(g)"/>
  </div>
</mat-card>
